import React, { useEffect, useState } from 'react';
import {
	DatePicker,
	DatePickerValue,
	OrderList,
} from '../components/StyledComponents';
import { Page } from '../components/ui/Page';
import { ButtonBar } from '../components/ui/ButtonBar';
import Store from '../store/Store';
import { Body } from '../components/layout/Body';

const status = [
	{ label: 'Alle Aufträge', value: '*', color: '#ffffff', id: 'button-orders-page-status-all' },
	{ label: 'Übermittelt', value: 'AWAITING_APPROVAL', color: '#ffffff', id: 'button-orders-page-status-awaiting-approval' },
	{ label: 'Ausstehend', value: 'AWAITING_PAYMENT', color: '#ffffff', id: 'button-orders-page-status-awaiting-payment' },
	{ label: 'In Bearbeitung', value: 'ONGOING', color: '#ffffff', id: 'button-orders-page-status-ongoing' },
	{ label: 'Verzögert', value: 'DELAYED', color: '#ffffff', id: 'button-orders-page-status-delayed' },
	{ label: 'Fertig', value: 'COMPLETED', color: '#ffffff', id: 'button-orders-page-status-completed' },
	{ label: 'Storniert', value: 'CANCELED', color: '#ffffff', id: 'button-orders-page-status-canceled' },
];

export interface OrdersPageProps {
	id?: string;
}

interface FilterState {
	state: string;
	from: number | null;
	to: number | null;
}

interface OrderItem {
	orderId: string;
	name: string;
	orderState: string;
	dateFrom: string;
	dateTo: string;
	mission: string;
	price: number;
	_dateFrom?: number;
	_dateTo?: number;
}

export default function OrdersPage(props: OrdersPageProps) {
	const [, orders] = Store.use('ordersError', 'orders') as [unknown, OrderItem[]];
	const [filter, setFilter] = useState<FilterState>({
		state: '*',
		from: null,
		to: null,
	});

	useEffect(() => {
		Store.loadOrders();
	}, []);

	const onSelect = (e: number) => {
		setFilter({ ...filter, state: status[e].value });
	};

	const onDateFilter = (value: DatePickerValue | null) => {
		const from = value?.startDate ? new Date(value.startDate).getTime() : null;
		const to = value?.endDate ? new Date(value.endDate).getTime() : null;
		setFilter({ ...filter, from, to });
	};

	const orderList = Array.isArray(orders) ? orders : [];
	const filteredOrders = orderList.filter(
		(e) =>
			(filter.state === '*' ? true : e.orderState.endsWith(filter.state)) &&
			(!filter.to || (e._dateFrom != null && e._dateTo != null && e._dateFrom <= filter.to && e._dateTo >= (filter.from ?? 0)))
		// && !e.orderState.includes('AWAITING_PAYMENT')
	);

	return (
		<Page>
			<Body id={props.id}>
				<div className="flex flex-col gap-4 w-full">
					<div className="flex flex-col w-full gap-3">
						<h1 className='text-xl h1-subpages mb-4'>Meine Aufträge</h1>
						<div className="flex items-center justify-between w-full">
							<ButtonBar data-pw="button-status" content={status} onSelect={onSelect} />
						</div>
						<div className='flex items-center gap-8 my-4'><p>Zeitraum wählen</p>
							<div className='max-w-[250px]'>
								<DatePicker aria-label="Zeitraum wählen" data-pw="date-picker-period" onChange={onDateFilter} allowPast={true} />
							</div>
						</div>


					</div>
				</div>

				<OrderList data-pw="order-list" title="Aufträge" orders={filteredOrders} />
			</Body>
		</Page>
	);
}
